// extracted by mini-css-extract-plugin
export default {"container":"src-components-Antd-SingleCollapse-css__container--yUMEL"};